import type { TFunction } from "i18next";
import i18n from "src/i18n";

type ApiErrorBody = {
  error?: unknown;
  code?: unknown;
  params?: unknown;
};

const responseBody = (error: unknown): ApiErrorBody | undefined =>
  (error as { response?: { data?: ApiErrorBody } })?.response?.data;

/**
 * Translated message for a failed API call: a known `code` from the server
 * wins, then the server's own `error` text, then the caller's fallback key.
 */
export const getApiErrorMessage = (
  error: unknown,
  t: TFunction,
  fallbackKey: string,
  fallbackParams?: Record<string, unknown>
): string => {
  const body = responseBody(error);
  if (typeof body?.code === "string") {
    const key = `errors.${body.code}`;
    if (i18n.exists(key)) {
      const params =
        body.params && typeof body.params === "object"
          ? (body.params as Record<string, unknown>)
          : undefined;
      return t(key, params);
    }
  }
  if (typeof body?.error === "string" && body.error) {
    return body.error;
  }
  return t(fallbackKey, fallbackParams);
};
